// import React from 'react';
// import ErrorMessage from './ErrorMessage';
// import styles from './DynamicFormRenderer.module.css';

// const TextAreaInput = ({ question, index, value, onChange, error, isSubmitted }) => {
//     return (
//         <div className={styles.questionWrapper}>
//             <div className={styles.questionHeader}>
//                 <span className={styles.questionNumber}>Q{index + 1}</span>
//                 <label className={styles.questionLabel}>
//                     {question.text}
//                     {question.required && <span className={styles.required}>*</span>}
//                 </label>
//             </div>
//             <div className={styles.inputWrapper}>
//                 <textarea
//                     value={value || ''}
//                     onChange={(e) => onChange(e.target.value)}
//                     placeholder={question.placeholder || 'Enter your detailed answer'}
//                     maxLength={question.maxLength}
//                     rows={5}
//                     disabled={isSubmitted}
//                     className={`${styles.textarea} ${error ? styles.inputError : ''} ${isSubmitted ? styles.disabled : ''}`}
//                 />
//                 {question.maxLength && (
//                     <div className={styles.charCount}>
//                         <span className={value && value.length > question.maxLength * 0.8 ? styles.charCountWarning : ''}>
//                             {(value || '').length} / {question.maxLength} characters
//                         </span>
//                     </div>
//                 )}
//                 {error && <ErrorMessage message={error} />}
//             </div>
//         </div>
//     );
// };

// export default TextAreaInput;

import React from 'react';
import ErrorMessage from './ErrorMessage';
import styles from './DynamicFormRenderer.module.css';

const TextAreaInput = ({ question, index, value, onChange, error, isSubmitted, disabled = false, onBlur }) => {
    const isDisabled = disabled;
    
    return (
        <div className={styles.questionWrapper}>
            <div className={styles.questionHeader}>
                <label className={styles.questionLabel}>
                    {question.text}
                    {question.required && <span className={styles.required}>*</span>}
                </label>
            </div>
            <div className={styles.inputWrapper}>
                <textarea
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                    onBlur={onBlur}
                    placeholder={question.placeholder || 'Enter your detailed answer'}
                    maxLength={question.maxLength}
                    rows={5}
                    disabled={isDisabled}
                    className={`${styles.textarea} ${error ? styles.inputError : ''} ${isDisabled ? styles.disabled : ''}`}
                />
                {question.maxLength && (
                    <div className={styles.charCount}>
                        <span className={value && value.length > question.maxLength * 0.8 ? styles.charCountWarning : ''}>
                            {(value || '').length} / {question.maxLength} characters
                        </span>
                    </div>
                )}
                {error && <ErrorMessage message={error} />}
            </div>
        </div>
    );
};

export default TextAreaInput;